import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0002',
    ecrans: ['00-2'],
    params: ['?prucleint', '?vaesysnatctb']
});
